import { Button, NonIdealState, Popover, Spinner } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import Padding from "common/fragments/Padding";
import { ButtonVariant } from "common/views/button/Button.view";
import MutationButton from "common/views/button/MutationButton";
import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import { Component } from "react";
import { MutationType } from "typegraph";
import { FlexJustify } from "../../../../common/fragments/Flex";
import { CardView } from "../../../../common/views/card/Card.view";
import { default as HeadingView, HeadingVariant } from "../../../../common/views/heading/Heading.view";
import { Query } from "../../../../core/api/typedQuery";
import { UserSubscription } from "../../entity/UserSubscription";
import UserSubscriptionForm from "./UserSubscriptionForm";

interface IUserSubscriptionManageProps {

}

const SubQuery = Query.queryMany<UserSubscription, any>(UserSubscription);

export default class UserSubscriptionManage extends Component<IUserSubscriptionManageProps> {

	private renderForm(sub: UserSubscription) {
		return (
			<Padding.Base>
				<UserSubscriptionForm targetUserId={sub.targetUserEntity.id} />
			</Padding.Base>
		);
	}

	private renderList(subs: UserSubscription[],refetch: () => void) {
		return subs.filter((s) => s.targetUserEntity != null).map((s) =>
			<CardView key={s.id} viewKey="user.sub">
				<Padding.Base>
					<FlexJustify>
						<HeadingView viewKey="user.sub.title" variant={HeadingVariant.H5}>{s.targetUserEntity.firstName} {s.targetUserEntity.lastName}</HeadingView>

						<div>
							<Popover content={this.renderForm(s)}>
								<Button minimal={true} icon={IconNames.COG} />
							</Popover>
							<MutationButton
								variant={ButtonVariant.PRIMARY}
								viewKey="user.sub.delete"
								clazz={UserSubscription}
								params={{ id: s.id }}
								clearCacheOnSuccess={true}
								method={MutationType.DELETE}
								onSuccess={()=>refetch()}
							>
								<Icon icon={IconNames.TRASH} />
							</MutationButton>
							
						</div>
					</FlexJustify>
				</Padding.Base>
			</CardView>
		);
	}

	public render() {
		return (
			<SubQuery params={{}}>
				{
					({data, loading, refetch}) => {

						if (loading) {
							return <Spinner/>;
						}

						if (!data) {
							return (
								<NonIdealState
									title={<Label k="user.subs.empty" v="No Subscriptions" />}
									description={<Label k="user.subs.empty.desc" v="Subscribe to a user with the follow button" />}
								/>
							);
						}

						return this.renderList(data,refetch);
					}
				}
			</SubQuery>
		);
	}

}



// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/UserSubscriptionManage.tsx